import { render, staticRenderFns } from "./PayRangeMarketDataTable.vue?vue&type=template&id=6ae247c4&scoped=true"
import script from "./PayRangeMarketDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeMarketDataTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeMarketDataTable.vue?vue&type=style&index=0&id=6ae247c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae247c4",
  null
  
)

export default component.exports